import { render, staticRenderFns } from "./tangniaobing.vue?vue&type=template&id=16bd78c6&"
import script from "./tangniaobing.vue?vue&type=script&lang=ts&"
export * from "./tangniaobing.vue?vue&type=script&lang=ts&"
import style0 from "./tangniaobing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports